<template>
    <client-page>
        <sub-visual v-bind="visual" />

        <div class="client-content-wrap pb-0">
            <section class="client-section pb-0">
                <v-container>
                    <business-intro v-bind="intro" />
                </v-container>
            </section>
        </div>
        <div class="client-content-wrap">
            <scrolldown-tail />

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">주요 프로그램</h2>
                    </div>

                    <v-row>
                        <v-col v-for="(program, index) in programs" :key="index" cols="12" lg="6">
                            <v-card max-width="588" color="#ddd" outlined class="border-radius-16 text-center h-100 mx-auto">
                                <v-img :src="program.image" alt="" />
                                <v-card-title class="justify-center pt-lg-40">
                                    <h3 class="tit tit--sm primary--text">
                                        {{ program.title }}
                                    </h3>
                                </v-card-title>
                                <v-card-text class="pb-lg-40">
                                    <p v-html="program.texts" class="page-text page-text--lg" />
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import BusinessIntro from "@/components/client/business/business-intro.vue";
import ScrolldownTail from "@/components/dumb/scrolldown-tail.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        BusinessIntro,
        ScrolldownTail,
    },
    data() {
        return {
            visual: {
                sh: "국내복지사업",
                tabActive: "연구개발 및 교육사업",
                text: "우리는 단순한 지원을 넘어, 지속 가능한 변화를 만들어 갑니다.",
                bg: "/images/business/domestic/visual.jpg",
                mobile: "/images/business/domestic/mobile-visual.jpg",
            },
            intro: {
                image: "/images/business/domestic/research/intro.jpg",
                title: "연구개발 및 교육사업",
                texts: "복지 현장에서 실제 적용할 수 있는 연구와 전문 인력 양성을 통해 이용자의 권익을 보호하고, <br class='d-none d-xl-block' />맞춤형 교육을 제공하여 복지의 질을 높이고자 합니다. 이를 위해 연구개발, 교육사업, 실천현장을 기반으로 지속 가능한 복지 혁신을 실현합니다.",
            },
            programs: [
                {
                    image: "/images/business/domestic/research/program-1.jpg",
                    title: "실천연구",
                    texts: "아동·중장년·노인 등 다양한 서비스 이용자의 권익과 복지를 높이기 위해, <br class='d-none d-xl-block' />실제 현장에서 적용할 수 있는 프로그램을 직접 연구·개발하고 있습니다.",
                },
                {
                    image: "/images/business/domestic/research/program-2.jpg",
                    title: "연구정보 교류 및 협력",
                    texts: "연구 결과를 널리 공유하고 보급하기 위해 <br class='d-none d-xl-block' />관련 기관과 학회 등과 활발히 교류·협력하고 있습니다.",
                },
                {
                    image: "/images/business/domestic/research/program-3.jpg",
                    title: "교육사업",
                    texts: "사업 역량을 높이기 위해 자체 교육 콘텐츠를 개발하여, 대상자의 욕구와 <br class='d-none d-xl-block' />특성에 맞춰 기획된 맞춤형 교육 프로그램을 운영하고 있습니다.",
                },
                {
                    image: "/images/business/domestic/research/program-4.jpg",
                    title: "전문인력 양성",
                    texts: "법인 내 사업기관 실무자와 복지 전문가를 위한 심화 교육을 운영하여, <br class='d-none d-xl-block' />더 높은 수준의 서비스를 제공하도록 지원합니다. 이를 통해 <br class='d-none d-xl-block' />재단 내부 역량을 강화하고, 사회복지 전반의 발전에 기여하고자 합니다.",
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.process-list {
    > [class*="col"] {
        .process-card {
            padding: 40px 14px;
            height: 100%;
            border-radius: 16px;
            max-width: 400px;
            margin: 0 auto;
            word-break: keep-all;
        }
        &:not(:last-child) {
            .process-card {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 50%;
                    bottom: -28px;
                    transform: translateX(50%) rotate(90deg);
                    width: 24px;
                    height: 24px;
                    background: url(/images/guide/legacy/process-arrow.svg) no-repeat center;
                }
            }
        }
    }
}
@media (min-width: 1024px) {
    .process-list {
        > [class*="col"] {
            &:not(:last-child) {
                .process-card {
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        right: -32px;
                        bottom: 50%;
                        transform: translatey(50%);
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }
}
</style>